const saleLogList = () => import('@/views/main/reserve/saleLog/saleLog.vue')
export default {
  path: '/main/reserve/saleLog',
  name: 'saleLogList',
  component: saleLogList,
  children: []
}
